var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.getButtonClassName,on:{"click":_vm.handleOnClickEvent}},[(_vm.icon)?_c('CustomIcon',{class:_vm.iconClass,attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }